import styled from "styled-components"
import { device } from "breakpoints"
import { MainColumn } from "components/MainColumn"
import { Teaser } from "components/Teaser"
import { InfoWrapper, Title } from "components/Teaser/style"
import { getGradient } from "helpers/getGradient"
import { getSolidColor } from "helpers/getSolidColor"
import { getSolidLightColor } from "helpers/getSolidLightColor"
export const WhyModuleContainer = styled.div`
  background: #f6f8fa;
  padding: 40px 0;
  position: relative;
  padding-bottom: 100px;
  margin-bottom: 60px;

  margin: ${props => `${props.theme.componentMargin.mobile}px auto`};

  @media (min-width: 500px) {
    padding-bottom: 150px;
  }
  @media ${device.desktop} {
    padding: 90px 0;
    padding-bottom: 150px;
    margin: ${props => `${props.theme.componentMargin.desktop}px auto`};
  }

  @media ${device.large} {
    padding: 120px 0;
    padding-bottom: 240px;
    margin: ${props => `${props.theme.componentMargin.large}px auto`};
  }

  @media ${device.big} {
    padding-bottom: 280px;
  }

  :after {
    content: "";
    position: absolute;
    height: 1px;
    width: 100vw;
    left: calc(50%);
    bottom: 0px;
    display: block;
    right: 0;
    transform-origin: 50%;
    background-image: ${props => getGradient(props.theme.site)};
    transform: skewY(4deg) translateX(-50%);

    @media ${device.tablet} {
      bottom: -40px;
      transform: skewY(+6deg) translateX(-50%);
    }

    @media ${device.desktop} {
      bottom: -80px;
      transform: skewY(7deg) translateX(-50%);
    }

    @media ${device.large} {
      bottom: -188px;
      transform: skewY(13deg) translateX(-50%);
    }

    @media ${device.big} {
      bottom: -250px;
      transform: skewY(10deg) translateX(-50%);
    }
  }
`

export const SlantMask = styled.div`
  position: absolute;
  height: 250px;
  width: 100%;
  left: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;

  :before {
    content: "";
    border-top: 1px solid;
    border-image-slice: 1;
    border-image-source: ${props => getGradient(props.theme.site)};
    background: white;
    width: 100vw;
    position: absolute;
    top:-1px;
    bottom: 0px;
    left: calc(50%);
    transform-origin: -50%;
    height: 250px;
    transform: skewY(-8deg) translateX(-50%) translateY(100%);

    @media ${device.tablet} {
      transform: skewY(-4deg) translateX(-50%) translateY(100%);
    }
  }
`

export const WhyModuleMainColumn = styled(MainColumn)`
  align-items: center;
`

export const WhyTitle = styled.h2`
  font-size: 36px;
  color: black;
  text-align: center;
  margin-bottom: 25px;

  @media ${device.desktop} {
    font-size: 44px;
    margin-bottom: 34px;
  }

  @media ${device.large} {
    font-size: 48px;
    margin-bottom: 40px;
  }
`

export const Subtext = styled.p`
  font-size: 16px;
  margin-bottom: 35px;
  text-align: center;
  max-width: 697px;

  @media ${device.desktop} {
    font-size: 18px;
    margin-bottom: 50px;
  }

  @media ${device.large} {
    font-size: 20px;
    margin-bottom: 70px;
  }
`

export const WhyTeaser = styled(Teaser)`
  height: 100%;

  :hover {
    ${Title} {
      text-transform: none;
      color: ${props => getSolidColor(props.theme.site)};
    }
  }

  svg {
    order: -1;
    height: 42px;
    width: auto;
    margin-bottom: 14px;
    defs > linearGradient {
      stop {
        stop-color: ${props => getSolidColor(props.theme.site)};
        :first-child {
          stop-color: ${props => getSolidLightColor(props.theme.site)};
        }
      }
    }

    @media ${device.desktop} {
      font-size: 26px;
    }
    @media ${device.large} {
      height: 60px;
      margin-bottom: 20px;
    }
  }

  h3 {
    order: 0;
    font-size: 24px;
    margin-bottom: 16px;
    text-transform: none !important;
    font-weight: 600;

    @media ${device.desktop} {
      font-size: 26px;
    }
    @media ${device.large} {
      font-size: 28px;
      margin-bottom: 25px;
    }
  }

  p,
  a {
    order: 1;
    font-size: 16px;
    margin-bottom: 18px;

    @media ${device.desktop} {
      font-size: 18px;
    }

    @media ${device.large} {
      font-size: 20px;
      margin-bottom: 25px;
    }
  }

  a {
    margin-top: auto;
    margin: 0;
    order: 2;
  }
  ${InfoWrapper} {
    padding: 0;
    justify-content: flex-start;
  }
`
